import type { DomainSchema, PdfCardDef } from '../types';

export const PHONE_NUMBERS = {
  priority: true,
  // The number itself is the content — no separate heading makes sense
  cardTitle: null,
  fields: {
    number: { type: 'text' },
    type: { type: 'text', label: 'Type' },
    extension: { type: 'text' },
    isPrimary: { type: 'checkbox', label: 'Primary number' },
    addedAt: { type: 'date', hidden: true },
  },
  layout: [
    [
      { field: 'number', width: 60 },
      { field: 'type', width: 40 },
    ],
    [{ field: 'extension' }, { field: 'isPrimary' }],
  ],
} satisfies DomainSchema;

/** Phone numbers are PII and never rendered in anonymised PDF exports. */
export const PhoneNumbersPdfCard: PdfCardDef = {
  styles: '',
  render: () => '',
};
